/*
* 出資者情報登録申請
*/
import ConsentApi from '@js/modules/consentApi/index';

export default class InvestorRegistrationLink {
  constructor() {
    this.$checkConsents = document.querySelectorAll('[data-target="investorRegistrationLink"]');
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$checkConsents, $item => {
      const url = $item.getAttribute('data-url');

      $item.addEventListener('click', () => {
        $item.classList.add('is-checked');
        window.open(url, '_blank');
        this.saveConsent($item); // DB保存で状態永続化

        // 状態変更を明示的に通知
        const linkId = $item.getAttribute('data-link-id');
        document.dispatchEvent(new CustomEvent('consent:changed', {
          detail: {
            type: 'investor-link',
            linkId: linkId,
            consented: true,
            element: $item
          }
        }));
      });
    });
  }

  saveConsent($item) {
    const linkId = $item.getAttribute('data-link-id');
    const endpoint = $item.getAttribute('data-save-consent-endpoint');

    if (!linkId || !endpoint) return;

    ConsentApi.saveInvestorConsent(linkId, endpoint);
  }

}
